import { useState } from "react";
import { navLinks, site, hotWords } from "@/mocks/gossip";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <header id="top" className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      {/* top ticker strip */}
      <div className="hidden md:block bg-foreground-950 text-background-50">
        <div className="mx-auto flex max-w-7xl items-center gap-6 px-4 md:px-6 py-1.5 text-xs">
          <span className="flex items-center gap-1.5 whitespace-nowrap font-label font-medium text-accent-400">
            <i className="ri-flashlight-fill text-accent-400"></i>
            现场热讯
          </span>
          <div className="relative flex-1 overflow-hidden text-foreground-200">
            <div className="ticker-track flex w-max gap-10 whitespace-nowrap">
              {hotWords.concat(hotWords).map((w, idx) => (
                <span key={`${w.key}-${idx}`} className="cursor-pointer hover:text-background-50 transition-colors">
                  {w.text}
                </span>
              ))}
            </div>
          </div>
          <span className="whitespace-nowrap text-foreground-400">2026.09.09 · 周四</span>
        </div>
      </div>

      {/* main nav */}
      <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 md:px-6 py-3 md:py-4">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="grid h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg md:text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-heading text-xl md:text-2xl font-bold tracking-wide text-foreground-950">
              {site.brand}
            </h1>
            <span className="mt-1 hidden text-[11px] text-foreground-500 sm:block">{site.tagline}</span>
          </span>
        </a>

        {/* desktop links */}
        <nav className="mx-auto hidden items-center gap-1 lg:flex">
          {navLinks.map((n) => (
            <a
              key={n.key}
              href={n.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-600"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex shrink-0 items-center gap-2 md:gap-3 lg:ml-0">
          <a href="#bbs" className="hidden items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 md:inline-flex">
            <i className="ri-message-3-line"></i>围观区
          </a>
          <a
            href="#bbs"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-add-line"></i>投稿爆料
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:px-6 lg:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-md bg-background-100 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索人物 / 事件 / 话题…"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </div>
          <div className="flex flex-wrap gap-1.5">
            {navLinks.map((n) => (
              <a
                key={n.key}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-full bg-background-100 px-3.5 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}